<script lang="ts" setup>
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';
import { formatNumber } from '@/home/utils/format';

const { $fetch } = useFetch();

const { data } = useAsyncData(
  'home:information:pinnded',
  () => $fetch('/information/v2/home_info_list', { method: 'post', data: { isSelected: 1, pageSize: 3 } }),
);
</script>

<template>
  <div>
    <h2 class="text-45 text-#0a0b5c font-bold leading-74">精选资讯</h2>
    <div class="mt-34 flex gap-32">
      <div v-for="item in data" :key="item.informationId" class="h-438 w-378 rounded-8 bg-#f9fbfe p-12">
        <img :src="item.informationUrl" :alt="item.informationMsg" class="h-240 w-354 rounded-8 object-cover">
        <div class="mx-8">
          <div class="mt-16 flex gap-16 text-14 text-#959ead font-semibold leading-20">
            <div v-for="value in item.labelNameList" :key="value.labelId" class="line-clamp-1 shrink">#{{ value.labelName }}</div>
          </div>
          <RouterLink :to="`/explore/journalism/detail/${item.informationId}`" class="mt-12 block" target="_blank">
            <h3 class="line-clamp-2 h-64 text-24 text-#183b56 font-medium leading-32">{{ item.informationTitle }}</h3>
          </RouterLink>
          <div class="mt-30 text-14 text-#1565d8 font-bold leading-20">
            <span>{{ formatNumber(item.informationViews) }}阅读</span>
            <span class="mx-4">·</span>
            <span>{{ formatNumber(item.informationLikeNum) }}点赞</span>
            <span class="mx-4">·</span>
            <span>{{ formatNumber(item.informationCollectNum) }}收藏</span>
            <span class="mx-4">·</span>
            <span>{{ formatNumber(item.informationCommentCount) }}评论</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
